import React from 'react';
import { Colors } from '.';
import { useObserver } from '../CodesThatsGottaGoSomewhereElse';
import { PopoutWidget } from '../app/canvas/workspace/widgets/WidgetInterface';
import { Icon } from '../concepts/resources/Icon';
import { BetterDropButton } from './DropButton';
import { Tip } from './Tip';

export type KeepOpenButtonProps = { value: boolean, onChange(next: boolean): void };
export const KeepOpenButton = ({ value, onChange }: KeepOpenButtonProps) => {

    return <Tip text={!value ? 'Keep Open' : 'Close'}>
        <BetterDropButton padding=".125" overflow=".125" onClick={() => onChange(!value)} style={{ color: Colors.text }}>
            {!value && <Icon src="deqo://icons/i8/push-pin" size="1.5" />}
            {value && <Icon src="deqo://icons/hero/x" size="1.5" />}
        </BetterDropButton>
    </Tip>;
};

export const KeepPopoutWidgetOpenButton = ({ widget }: { widget: PopoutWidget }) => {
    const { autoClose } = useObserver(widget);
    return <KeepOpenButton value={!autoClose} onChange={x => widget.update({ autoClose: !x, open: x })} />;
};
